import styled from 'styled-components';
import media from '../../../styled/media';

export const H3 = styled.h3`
  font-size: 24px;
  line-height: 36px;
  margin: 24px 0;
  font-weight: 400;
  ${media.tablet`
    font-size: 34px;
    line-height: 48px;
  `}
`;

export const Intro = styled.div`
  position: relative;
  height: 480px;
  ${media.tablet`
    height: 640px;
  `}
`;

export const DemoInner = styled.div`
  height: 488px;
  padding: 40px;
  text-align: center;
  background: url('/images/success-stories/calendar.jpg') no-repeat bottom;
  background-size: contain;
  ${media.tablet`
    height: 608px;
    text-align: initial;
    display: flex;
    align-items: center;
    background-position: right;
  `}
`;

export const Testimonials = styled.div`
  background: #f5f5f5;
  padding: 40px 0 16px;
  text-align: center;
  ${media.tablet`
    padding: 96px 0 72px;
  `}
`;

export const TestimonialsQuote = styled(H3)`
  font-style: italic;
  ${media.tablet`
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  `}
`;

export const TestimonialsOrigin = styled.p`
  ${media.tablet`
    font-size: 18px;
  `}
`;

export const ChallengeSolution = styled.div`
  background: #f5f5f5;
  padding: 16px 0;
  ${media.tablet`
    padding: 72px 0;
  `}
`;

export const ChallengeSolutionInner = styled.div`
  ${media.tablet`
    display: flex;
    position: relative;
  `}
`;

export const ChallengeSolutionCell = styled.div`
  ${media.tablet`
    width: 50%;
    padding: 0 100px;
  `}
  & + &:before {
    display: block;
    content: '';
    width: 20px;
    height: 38px;
    background: url('/images/success-stories/arrow-down.svg') no-repeat center;
    left: 50%;
    position: relative;
    margin: 0 0 0 -10px;
    ${media.tablet`
      width: 90px;
      height: 20px;
      background-image: url('/images/success-stories/arrow-right.svg');
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -10px 0 0 -45px;
    `}
  }
  ${H3} {
    text-align: center;
    ${media.tablet`
      text-align: initial;
    `}
  }
`;

export const Description = styled.div`
  padding: 16px 0;
  ${media.tablet`
    padding: 72px 0;
    display: flex;
    align-items: center;
  `}
`;

export const DescriptionImage = styled.div`
  display: none;
  ${media.tablet`
    display: flex;
    width: 50%;
    justify-content: center;
  `}
`;

export const DescriptionText = styled.div`
  ${media.tablet`
    width: 50%;
  `}
`;

export const Motivation = styled.div`
  padding: 16px 0;
  ${media.tablet`
    display: flex;
    align-items: center;
    padding: 96px 0;
  `}
`;

export const MotivationText = styled.div`
  ${media.tablet`
    width: 50%;
  `}
`;

export const MotivationImage = styled.div`
  ${media.tablet`
    width: 50%;
    text-align: center;
  `}
`;
